import ASCIIFolder from 'fold-to-ascii'

export function normalizeStringWithFolding (str: string) {
  return ASCIIFolder.foldMaintaining(str.trim().toLowerCase().normalize())
}
